import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { usuariosAPI } from '../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import '../Usuarios.css';

const Usuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [permisosDe, setPermisosDe] = useState(null);
  useAuth();

  useEffect(() => {
    loadUsuarios();
  }, []);

  const loadUsuarios = async () => {
    try {
      setLoading(true);
      const response = await usuariosAPI.getAll();
      if (response.success) {
        setUsuarios(response.data);
      }
    } catch (error) {
      toast.error('Error al cargar usuarios');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Está seguro de eliminar este usuario?')) return;

    try {
      const response = await usuariosAPI.delete(id);
      if (response.success) {
        toast.success('Usuario eliminado exitosamente');
        loadUsuarios();
      }
    } catch (error) {
      toast.error(error.message || 'Error al eliminar usuario');
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <div className="usuarios pagina-listado pagina-listado--scroll">
      <div className="page-header">
        <h1>Usuarios</h1>
        <Link to="/usuarios/nuevo" className="btn-primary">Nuevo Usuario</Link>
      </div>

      <div className="listado-panel clientes-listado listado-controles">
        <div className="listado-panel-cuerpo clientes-listado-cuerpo">
          <div className="listado-tabla-area clientes-listado-tabla-area">
            <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Nombre</th>
              <th>Email</th>
              <th>Permisos</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {usuarios.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">No hay usuarios registrados</td>
              </tr>
            ) : (
              usuarios.map(usuario => (
                <tr key={usuario.id}>
                  <td>{usuario.username}</td>
                  <td>{usuario.nombre}</td>
                  <td>{usuario.email || '-'}</td>
                  <td>
                    <button
                      type="button"
                      className="btn-secondary"
                      onClick={() => setPermisosDe(usuario)}
                    >
                      {usuario.permisos?.length ? `${usuario.permisos.length} permisos` : 'Sin permisos'}
                    </button>
                  </td>
                  <td>
                    <span className={`badge ${usuario.activo ? 'activo' : 'inactivo'}`}>
                      {usuario.activo ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <Link to={`/usuarios/editar/${usuario.id}`} className="btn-edit">Editar</Link>
                      <button onClick={() => handleDelete(usuario.id)} className="btn-delete">Eliminar</button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
            </div>
          </div>
        </div>
      </div>
      {permisosDe && (
        <div className="permisos-modal-overlay" onClick={() => setPermisosDe(null)}>
          <div className="permisos-modal" role="dialog" aria-modal="true" aria-labelledby="permisos-modal-titulo" onClick={(e) => e.stopPropagation()}>
            <div className="permisos-modal-header">
              <h2 id="permisos-modal-titulo">Permisos de {permisosDe.nombre || permisosDe.username}</h2>
              <button type="button" className="btn-secondary" onClick={() => setPermisosDe(null)}>Cerrar</button>
            </div>
            <ul className="permisos-modal-lista">
              {(permisosDe.permisos || []).length === 0 ? (
                <li>Sin permisos</li>
              ) : (
                permisosDe.permisos.map((permiso) => <li key={permiso}>{permiso}</li>)
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default Usuarios;

